import { ChartType } from '../types.ts';

export const chartTypeValueToKey: Record<string, keyof typeof ChartType> = Object.entries(
  ChartType
).reduce(
  (acc, [key, value]) => {
    acc[value] = key as keyof typeof ChartType;
    return acc;
  },
  {} as Record<string, keyof typeof ChartType>
);
